module.exports = __webpack_public_path__ + "media/images/emblems/Trimmis_wappen-e89f188086301134e41bc0ac7c9b4e22.svg";